import moment from 'moment';

export const formatSessionLabel = (
  sessionDateTime: string,
  sessionDurationInMinutes: number,
) => {
  const momentStartDate = moment(sessionDateTime);
  const startDay = momentStartDate.clone().startOf('day');

  const formattedDate = momentStartDate.format('MMMM Do');
  const formattedStartTime =
    momentStartDate.minute() === 0
      ? momentStartDate.format('h A')
      : momentStartDate.format('h:mm A');

  const momentEndDate = momentStartDate.add(
    sessionDurationInMinutes,
    'minutes',
  );
  const formattedEndTime =
    momentEndDate.minute() === 0
      ? momentEndDate.format('h A')
      : momentEndDate.format('h:mm A');

  // A stay that ends on a later day (a multi-day rental, an overnight) names that day too.
  const formattedEnd = momentEndDate.isSame(startDay, 'day')
    ? formattedEndTime
    : `${momentEndDate.format('MMMM Do')}, ${formattedEndTime}`;

  return `${formattedDate}, ${formattedStartTime} - ${formattedEnd}`;
};
